(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adult-mega-navigation"] && !Shopify.designMode) return;
  try {
    
  const initAdultMegaNav = (root) => {
    if (!root || root.dataset.adultMegaNavReady === 'true') return;
    root.dataset.adultMegaNavReady = 'true';

    const panelItems = Array.from(root.querySelectorAll('[data-adult-mega-item].adult-mega-nav__item--has-panel'));
    let hideTimer = null;

    const setScrolled = () => {
      if (root.dataset.transparentOnScroll !== 'true') return;
      const isScrolled = window.scrollY > 12;
      root.classList.toggle('is-scrolled', isScrolled);
      document.body.classList.toggle('adult-mega-nav-scrolled', isScrolled);
    };

    const setPanelOpen = (item) => {
      window.clearTimeout(hideTimer);
      panelItems.forEach((panelItem) => {
        panelItem.classList.toggle('is-open', panelItem === item);
      });
      root.classList.add('is-panel-open');
      document.body.classList.add('adult-mega-menu-open');
    };

    const closePanels = () => {
      panelItems.forEach((panelItem) => panelItem.classList.remove('is-open'));
      root.classList.remove('is-panel-open');
      document.body.classList.remove('adult-mega-menu-open');
    };

    const scheduleClose = () => {
      window.clearTimeout(hideTimer);
      hideTimer = window.setTimeout(() => {
        if (root.matches(':hover') || root.matches(':focus-within')) return;
        closePanels();
      }, 180);
    };

    panelItems.forEach((item) => {
      item.addEventListener('mouseenter', () => setPanelOpen(item));
      item.addEventListener('focusin', () => setPanelOpen(item));
    });

    root.addEventListener('mouseleave', scheduleClose);
    root.addEventListener('focusout', scheduleClose);

    document.addEventListener('click', (event) => {
      if (root.contains(event.target)) return;
      closePanels();
    });

    root.addEventListener('keydown', (event) => {
      if (event.key !== 'Escape') return;
      closePanels();
    });

    window.addEventListener('scroll', setScrolled, { passive: true });
    setScrolled();
  };

  document.querySelectorAll('[data-adult-mega-nav]').forEach(initAdultMegaNav);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-adult-mega-nav]').forEach(initAdultMegaNav);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
